import React, { createContext, useContext, useState, useEffect } from 'react';
import Cookies from 'js-cookie';
import { config } from '../config/config';

const UserContext = createContext();

export const useUser = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const normalizeUserData = (userData) => {
    if (!userData) return null;
    const email = (userData.email || "").toLowerCase();
    let roles = Array.isArray(userData.roles)
      ? [...userData.roles]
      : typeof userData.roles === "string"
        ? userData.roles.split(",").map(r => r.trim())
        : [];

    // Safeguard: Automatically grant appropriate admin role if known admin email has default 'User' role
    if (email === "arinfotechsolutions38@gmail.com" || email === "admin@arinfotechsolutions.com" || email === "admin@arinfotech.com") {
      if (!roles.includes("Super Admin")) {
        roles = ["Super Admin", ...roles.filter(r => r !== "User")];
      }
    } else if (email === "sales@arinfotechsolutions.com") {
      if (!roles.includes("Admin") && !roles.includes("Super Admin")) {
        roles = ["Admin", ...roles.filter(r => r !== "User")];
      }
    }

    return {
      ...userData,
      roles: roles.length > 0 ? roles : (userData.roles || ["User"])
    };
  };

  useEffect(() => {
    try {
      const savedUserStr = localStorage.getItem('ar_user') || localStorage.getItem('amrutha_user');
      if (savedUserStr) {
        const parsed = JSON.parse(savedUserStr);
        const normalized = normalizeUserData(parsed);
        setUser(normalized);

        // Ensure cookie is in sync with path '/'
        const savedToken = localStorage.getItem('ar_token');
        if (savedToken && normalized?.id) {
          const authData = { token: savedToken, loginUserId: normalized.id };
          Cookies.set(config.cookieName, JSON.stringify(authData), { expires: 30, path: '/' });
        }
      } else {
        const savedCookieStr = Cookies.get(config.cookieName);
        if (savedCookieStr) {
          try {
            const parsedCookie = JSON.parse(savedCookieStr);
            if (parsedCookie.loginUserId) {
              // Minimal fallback
              setUser({ id: parsedCookie.loginUserId, roles: ["User"] });
            }
          } catch (e) {}
        }
      }
    } catch (err) {
      console.error("Error restoring user session:", err);
    }
    setLoading(false);
  }, []);

  const login = (userData, token) => {
    const normalized = normalizeUserData(userData);
    setUser(normalized);
    
    // Store in structure expected by apiServices with root path '/'
    const authData = {
      token: token,
      loginUserId: normalized.id
    };
    
    Cookies.set(config.cookieName, JSON.stringify(authData), { expires: 30, path: '/' });
    const userJson = JSON.stringify(normalized);
    localStorage.setItem('ar_user', userJson);
    localStorage.setItem('amrutha_user', userJson); // legacy sync
    if (token) {
      localStorage.setItem('ar_token', token);
    }
  };

  const logout = (redirectUrl = '/login') => {
    setUser(null);
    Cookies.remove(config.cookieName, { path: '/' });
    localStorage.removeItem('ar_user');
    localStorage.removeItem('amrutha_user');
    localStorage.removeItem('ar_token');
    localStorage.removeItem('ar_dashboard_logged_out');
    sessionStorage.clear();
    const finalUrl = (typeof redirectUrl === 'string' && redirectUrl.startsWith('/')) ? redirectUrl : '/login';
    window.location.href = finalUrl;
  };

  return (
    <UserContext.Provider value={{ user, loading, login, logout }}>
      {children}
    </UserContext.Provider>
  );
};

